document.addEventListener("DOMContentLoaded", () => {
  console.log("🔒 Mindestmengen-Regeln geladen");

  const minQtyMap = window.minQtyMap || {};
  const originalFetch = window.fetch;

  //-----------------------------------------------------------
  // REMOVE-ERKENNUNG (Klick auf Remove Button)
  //-----------------------------------------------------------
    document.addEventListener("click", (ev) => {
    const btn = ev.target.closest("cart-remove-button a, a.button--tertiary");

    if (btn && btn.href.includes("quantity=0")) {
        console.log("🟢 Entfernen erkannt → Minus-Buttons deaktiviert");
        window.__forceRemove = true;

        // Minus-Buttons blockieren, damit Shopify kein -1 sendet
        document.querySelectorAll('.quantity__button[name="minus"]').forEach(b => {
        b.disabled = true;
        b.classList.add("force-remove-lock");
        });
    }
    });


  //-----------------------------------------------------------
  // FETCH INTERCEPTOR
  //-----------------------------------------------------------
    window.fetch = async function(resource, config) {

    // Wenn Entfernen aktiv → NICHT blockieren
    if (window.__forceRemove === true) {
        console.log("🟢 Entfernen erlaubt (Fetch)");

        setTimeout(() => {
        document.querySelectorAll('.quantity__button.force-remove-lock').forEach(b => {
            b.disabled = false;
            b.classList.remove("force-remove-lock");
        });
        }, 500);

        window.__forceRemove = false;
        return originalFetch(resource, config);
    }

    // Prüfen ob es eine Change-Operation ist
    if (typeof resource === "string" && resource.includes("/cart/change")) {

      try {
        const payload = JSON.parse(config.body);
        const line = payload.line;
        const qty = parseInt(payload.quantity, 10);

        const minQty = minQtyMap[line] ? parseInt(minQtyMap[line], 10) : 1;

        // Entfernen (qty=0) immer erlauben
        if (qty === 0) {
          console.log("🟢 Entfernen per qty=0 erlaubt");
          return originalFetch(resource, config);
        }

        // Mindestmenge verhindern
        if (qty < minQty) {
          console.warn("❌ Blockiert, Mindestmenge:", minQty);

          return Promise.resolve(
            new Response(
              JSON.stringify({
                status: "blocked",
                line: line,
                corrected: minQty,
                error: `Die Mindestmenge beträgt ${minQty}.`
              }),
              { status: 200 }
            )
          );
        }

      } catch (err) {
        console.error("Interceptor Fehler:", err);
      }
    }

    return originalFetch(resource, config);
  };


  //-----------------------------------------------------------
  // FORM-SUBMIT INTERCEPTOR (für Themes ohne fetch)
  //-----------------------------------------------------------
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!form || form.id !== "cart") return;

    console.log("📝 Cart Submit erkannt");

    // Entfernen aktiv?
    if (window.__forceRemove === true) {
      console.log("🟢 Entfernen per Submit erlaubt");
      window.__forceRemove = false;
      return; // NICHT blockieren
    }

    let block = false;
    form.querySelectorAll("input.quantity__input").forEach((input) => {
      const line = input.dataset.index;
      const qty = parseInt(input.value, 10);
      const minQty = minQtyMap[line] ? parseInt(minQtyMap[line], 10) : 1;

      if (qty === 0) {
        console.log("🟢 Entfernen im Submit erlaubt");
        return;
      }

      if (qty < minQty) {
        console.warn(`❌ Blockiert: Mindestmenge ${minQty}`);
        input.value = minQty;
        block = true;
      }
    });

    if (block) {
      e.preventDefault();
    }
  });

});